import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import { hasDuplicateLanguages } from "@faire/web--source/common/localization/languageOptions";
import { LanguageDropdown } from "@faire/web--source/ui/LanguageSelector/LanguageDropdown";
import { useMemo } from "react";
import * as React from "react";
import styled, { css } from "styled-components";
export var LanguageSelectorDropdown = function(props) {
    var availableLocalesHasDuplicateLanguages = useMemo(function() {
        return hasDuplicateLanguages(props.availableLocales);
    }, [
        props.availableLocales
    ]);
    var _props_position;
    return /*#__PURE__*/ _jsx(OuterDropdownWrapper, {
        $position: (_props_position = props.position) !== null && _props_position !== void 0 ? _props_position : "downRight",
        $showFullLocale: availableLocalesHasDuplicateLanguages,
        className: props.className,
        children: /*#__PURE__*/ _jsx(DropdownWrapper, {
            children: /*#__PURE__*/ _jsx(LanguageDropdown, _object_spread_props(_object_spread({}, props), {
                eventName: "web-view-language-selector"
            }))
        })
    });
};
var getPositionStyles = function(props) {
    var $position = props.$position;
    switch($position){
        case "downLeft":
            return css([
                "top:100%;right:11px;"
            ]);
        case "up":
            return css([
                "right:11px;bottom:100%;"
            ]);
        case "downRight":
            return css([
                "top:100%;left:12px;"
            ]);
        default:
            return exhaustiveSwitchWithDefault(css([
                "top:100%;left:12px;"
            ]))($position);
    }
};
var getWidth = function(props) {
    if (props.$showFullLocale) {
        return "170px";
    } else {
        return "142px";
    }
};
var OuterDropdownWrapper = styled.div.withConfig({
    componentId: "sc-8d53f0e9-0"
})([
    "position:absolute;width:",
    ";background:white;border:1px solid ",
    ";box-shadow:0 1px 1px ",
    ";z-index:2;",
    ";"
], function(props) {
    return getWidth(props);
}, Core.border.muted, Core.surface.subdued, function(props) {
    return getPositionStyles(props);
});
var DropdownWrapper = styled.div.withConfig({
    componentId: "sc-8d53f0e9-1"
})([
    "padding:24px 16px 0 16px;"
]);
